/** 渠道中心 · 平台品牌色（装饰性设计 token，非业务数据——跟 STATUS_TONE 一类静态色板同性质）。 */
export const PLATFORM_BRAND: Record<string, { abbr: string; bg: string }> = {
  gyg: { abbr: "GYG", bg: "#FF5533" },
  viator: { abbr: "V", bg: "#33AA66" },
};

export function relativeTime(iso: string | null): string {
  if (!iso) return "—";
  const d = new Date(iso).getTime();
  const diffMs = Date.now() - d;
  const min = Math.floor(diffMs / 60000);
  if (min < 1) return "刚刚";
  if (min < 60) return `${min} 分钟前`;
  const hr = Math.floor(min / 60);
  if (hr < 24) return `${hr} 小时前`;
  return new Date(iso).toLocaleDateString("zh-CN");
}
